export const CREATE_MIS_FORM_FIELD = 'Create_Mis_Form_Field';
export const CREATE_MIS_FORM_FIELD_SUCCESS = 'Create_Mis_Form_Field_Request_Success';
export const CREATE_MIS_FORM_FIELD_FAILURE = 'Create_Mis_Form_Field_Request_Failure';

export const createMisFormField = (data) => {
    return {
        type: CREATE_MIS_FORM_FIELD,
        data
    }
}
export const createMisFormFieldSuccess = (data) => {
    return {
        type: CREATE_MIS_FORM_FIELD_SUCCESS,
        data
    }
}
export const createMisFormFieldFailure = (data) => {
    return {
        type: CREATE_MIS_FORM_FIELD_FAILURE,
        data
    }
}

export const GET_MIS_FORM_FIELD_FILTERED = 'Get_Mis_Form_Field_Filtered';
export const GET_MIS_FORM_FIELD_FILTERED_SUCCESS = 'Get_Mis_Form_Field_Filtered_Success';
export const GET_MIS_FORM_FIELD_FILTERED_FAILURE = 'Get_Mis_Form_Field_Filtered_Failure';

export const getMisFormFieldFilteredList = (data) => {
    return {
        type: GET_MIS_FORM_FIELD_FILTERED,
        data
    }
}
export const getMisFormFieldFilteredListSuccess = (data) => {
    return {
        type: GET_MIS_FORM_FIELD_FILTERED_SUCCESS,
        data
    }
}
export const getMisFormFieldFilteredListFailure = (data) => {
    return {
        type: GET_MIS_FORM_FIELD_FILTERED_FAILURE,
        data
    }
}

export const MASTER_DATA_LIST="Master_Data_List";
export const MASTER_DATA_LIST_SUCCESS="Master_Data_List_Success";
export const MASTER_DATA_LIST_FAILURE="Master_Data_List_Failure";

export const getMasterData = (data) => {
    return {
        type: MASTER_DATA_LIST,
        data
    }
}
export const getMasterDataSuccess = (data) => {
    return {
        type: MASTER_DATA_LIST_SUCCESS,
        data
    }
}
export const getMasterDataFailure = (data) => {
    return {
        type: MASTER_DATA_LIST_FAILURE,
        data
    }
}